import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import StyledComponentsTheme from './StyledComponentsTheme';
import ClientProvider from './client';
export default createDemo(import.meta.url, StyledComponentsTheme, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/integrations/interoperability/demos/styled-components-theme/StyledComponentsTheme.tsx",
    "fileName": "StyledComponentsTheme.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { createTheme, styled, ThemeProvider, darken } from '@mui/material/styles';\nimport Slider from '@mui/material/Slider';\nimport Box from '@mui/material/Box';\n\nconst customTheme = createTheme({\n  palette: {\n    primary: {\n      main: '#20b2aa',\n    },\n  },\n});\n\nconst CustomizedSlider = styled(Slider)(\n  ({ theme }) => `\n  color: ${theme.palette.primary.main};\n\n  :hover {\n    color: ${darken(theme.palette.primary.main, 0.2)};\n  }\n`,\n);\n\nexport default function StyledComponentsTheme() {\n  return (\n    <Box sx={{ width: 300 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <ThemeProvider theme={customTheme}>\n        <CustomizedSlider defaultValue={30} />\n      </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 31,
        "focusedLines": 3,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { createTheme, styled, ThemeProvider, darken } from '@mui/material/styles';\nimport Slider from '@mui/material/Slider';\nimport Box from '@mui/material/Box';\n\nconst customTheme = createTheme({\n  palette: {\n    primary: {\n      main: '#20b2aa',\n    },\n  },\n});\n\nconst CustomizedSlider = styled(Slider)(\n  ({ theme }) => `\n  color: ${theme.palette.primary.main};\n\n  :hover {\n    color: ${darken(theme.palette.primary.main, 0.2)};\n  }\n`,\n);\n\nexport default function StyledComponentsTheme() {\n  return (\n    <Box sx={{ width: 300 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <ThemeProvider theme={customTheme}>\n        <CustomizedSlider defaultValue={30} />\n      </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 26
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "theme"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "customTheme"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 27
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "CustomizedSlider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "defaultValue"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "30"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 28
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 31,
    "focusedLines": 3,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/Slider",
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
